// extracted by mini-css-extract-plugin
export default {"robotoLabel":"InternalNotePriority_robotoLabel__ED1xX"};